module.exports = __webpack_public_path__ + "28b8f55e4a1cb350b0ea05d6b7768961.svg";